import { render, staticRenderFns } from "./Monitors.vue?vue&type=template&id=28e67ffd&scoped=true&lang=pug&"
import script from "./Monitors.vue?vue&type=script&lang=js&"
export * from "./Monitors.vue?vue&type=script&lang=js&"
import style0 from "./Monitors.vue?vue&type=style&index=0&id=28e67ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e67ffd",
  null
  
)

export default component.exports